import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { logout } from '../api/auth';
import {
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Button,
  Tooltip,
  Typography,
} from '@mui/material';
import {
  Menu as MenuIcon,
  Business as BusinessIcon,
  Campaign as CampaignIcon,
  LocalOffer as CouponIcon,
  Logout as LogoutIcon,
  Description as DescriptionIcon,
} from '@mui/icons-material';

const drawerWidth = 240;
const collapsedWidth = 64;

const ImplPageLayout = () => {
  const [open, setOpen] = useState(true);
  const navigate = useNavigate();

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('ログアウト失敗:', error);
    } finally {
      localStorage.clear();
      navigate('/login');
    }
  };

  const menuItems = [
    {
      text: '企業登録',
      icon: <BusinessIcon />,
      path: '/registration',
    },
    {
      text: '企業管理',
      icon: <CampaignIcon />,
      path: '/campaignlist',
    },{
      text: 'クーポン管理',
      icon: <CouponIcon />,
      path: '/coupon-management',
    },{
      text: '利用規約編集',
      icon: <DescriptionIcon />,
      path: '/terms-edit',
    }
  ];

  const drawer = (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box
        sx={{
          p: 2,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <IconButton
          onClick={handleDrawerToggle}
          sx={{ mr: open ? 2 : 'auto', p: open ? 1 : 0.5 }}
        >
          <MenuIcon />
        </IconButton>
        {open && (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="h6" noWrap>
              企業ポータル
            </Typography>
          </Box>
        )}
      </Box>

      <Divider />

      <Box sx={{ flexGrow: 1 }}>
        <List>
          {menuItems.map((item) => (
            <ListItem key={item.text} disablePadding>
              <Tooltip title={!open ? item.text : ''} placement="right">
                <ListItemButton
                  onClick={() => {
                    navigate(item.path);
                  }}
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 'auto',
                      justifyContent: 'center',
                    }}
                  >
                    {item.icon}
                  </ListItemIcon>
                  {open && <ListItemText primary={item.text} />}
                </ListItemButton>
              </Tooltip>
            </ListItem>
          ))}
        </List>
      </Box>

      <Divider />

      <Box sx={{ p: open ? 2 : 1, mt: 'auto' }}>
        <Tooltip title={!open ? 'ログアウト' : ''}>
          <Button
            fullWidth={open}
            variant="outlined"
            color="error"
            onClick={handleLogout}
            sx={{
              minWidth: open ? 'auto' : 40,
              width: open ? '100%' : 40,
              height: 40,
              borderRadius: open ? 2 : '50%',
              justifyContent: open ? 'flex-start' : 'center',
              px: open ? 2 : 0,
            }}
          >
            <LogoutIcon sx={{ mr: open ? 2 : 0 }} />
            {open && 'ログアウト'}
          </Button>
        </Tooltip>
      </Box>
    </Box>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      <Box
        component="nav"
        sx={{ width: open ? drawerWidth : collapsedWidth, flexShrink: 0 }}
      >
        <Drawer
          variant="permanent"
          sx={{
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: open ? drawerWidth : collapsedWidth,
              transition: 'width 0.3s ease',
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: `calc(100% - ${open ? drawerWidth : collapsedWidth}px)`,
          transition: 'width 0.3s ease',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default ImplPageLayout;
